export default "__VITE_ASSET__Up7P8X9c__"